// Helpers for reading OCR/extraction results consistently across the WO flows.
//
// Specialized document prompts return the document's own number under a TYPE-SPECIFIC field
// (passportNumber, visaNumber, certificateNumber, licenseNumber, emiratesIdNumber) rather than a
// generic `documentNumber` — and some docs (e.g. a visa) carry BOTH a passportNumber and a
// visaNumber, so the tracking number must be chosen by the document's own type, not guessed.

/** The extraction field that holds THIS document's own number, for the given document-type code. */
export const docNumberFieldFor = (docType) => {
  const t = (docType || '').toLowerCase();
  if (t.includes('passport')) return 'passportNumber';
  if (t.includes('visa')) return 'visaNumber';
  if (t.includes('emirates')) return 'emiratesIdNumber';
  if (t.includes('ohc') || t.includes('occupational')) return 'certificateNumber';
  if (t.includes('driving') || t.includes('licen')) return 'licenseNumber';
  // Police clearance certificate, general, and everything else already use `documentNumber`.
  return 'documentNumber';
};

const cleanVal = (v) => {
  if (v === null || v === undefined) return '';
  const s = String(v).trim();
  return (!s || s.toLowerCase() === 'null') ? '' : s;
};

/**
 * The document's own number from an extraction result, chosen by its type — e.g. a visa returns its
 * visaNumber (not the passportNumber it also carries). Falls back to a generic `documentNumber`.
 */
export const resolveExtractedDocNumber = (extracted, docType) => {
  if (!extracted) return '';
  const field = docNumberFieldFor(docType);
  return cleanVal(extracted[field]) || cleanVal(extracted.documentNumber);
};
